<template>
  <div v-if="!isSVG" class="app-icon font-icon">
    <i
      class="material-icons"
      :style="{
        'font-size': fontSize,
        color,
      }"
    >
      <slot />
    </i>
  </div>

  <div
    v-else
    class="app-icon svg"
    :style="{
      width,
      height,
      color,
      'background-color': backgroundColor,
    }"
  >
    <div
      v-if="src"
      :style="{
        'mask-image': `url('${src}')`,
      }"
      class="mask"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'AppIcon',

  props: {
    size: {
      type: String,
    },

    color: {
      type: String,
    },

    backgroundColor: {
      type: String,
    },

    src: {
      type: String,
    },
  },

  computed: {
    isSVG() {
      const src = this.src || ''

      return src.endsWith('.svg')
    },

    fontSize() {
      if (this.isSVG === true) return

      return this.size
    },

    width() {
      if (this.isSVG === false) return

      return this.$attrs.width || this.size
    },

    height() {
      if (this.isSVG === false) return

      return this.$attrs.height || this.size
    },
  },
}
</script>

<style lang="scss" scoped>
@import 'material-icons/iconfont/material-icons.css';

.app-icon {
  &.svg {
    $minSize: 16px;
    display: block;
    min-width: $minSize;
    min-height: $minSize;
    position: relative;

    > .background-color {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      z-index: 0;
    }

    > .mask {
      width: 100%;
      height: 100%;
      min-height: inherit;
      background-color: currentColor;
      -webkit-mask-size: contain;
      -webkit-mask-position: center;
      -webkit-mask-repeat: no-repeat;
      mask-size: contain;
      mask-position: center;
      mask-repeat: no-repeat;
    }
  }

  &.font-icon {
    display: inline-block;
    font-size: 100%;
    line-height: 100%;
    text-align: center;
    vertical-align: middle;

    &:last-child,
    &:only-child {
      margin-right: 0;
    }

    > .material-icons {
      font-size: inherit;
      line-height: inherit;
      max-width: 1em;
      display: block;
    }
  }
}
</style>
